import React from 'react';
import { CourseType } from '../types';
import { text } from '../text';
import { utils } from '../utils';
import { hooks } from '../hooks';
import { theme } from '../constants';
import { course as elements } from '../course';
import { CourseInWishlist } from './CourseInWishlist';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules'; // ✅ Swiper pagination module
import 'swiper/css';
import 'swiper/css/pagination'; // ✅ Swiper dots style
import { BookingSvg } from '../assets/svg/Booking';


type Feature = {
    feature_id: number;
    feature_name: string;
    icon: string;
};

type Property = {
    property_id: string;
    property_name: string;
    address: string;
    locality_id: string;
    locality_name: string | null;
    city_id: string;
    city_name: string;
    pincode: string;
    state: string;
    features: Feature[] | null;
    // photos: any; // Replace `any` if photo type is known
    photos: string[] | null;
    minimum_rent: number;
};





type Props = {
    isLast?: boolean;
    // course: CourseType;
    course: Property;
    section: 'top rated';
    index: number;
};

export const SerachResultCard: React.FC<Props> = ({
    course,
    section,
    isLast,
    index
}) => {
    const navigate = hooks.useNavigate();
    const fallbackImage = "https://img.freepik.com/free-photo/aerial-shot-city-buildings-toa-payoh-singapore-blue-sky_181624-14554.jpg?uid=R26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740";

    // fallback if photos is null, undefined, or empty
    const imagesToShow = course.photos && course.photos.length > 0
        ? course.photos
        : [fallbackImage];

    // console.log("🔍 Course Debug - SearchResultCard:", course); 
    return (
        <div className='container' >
            <div
                className='sperate-card-container'>
                <div className='sperate-card-container_img'>
                    {/* <div className="floating-tag">{course.tags}</div> */}
                    <div className='SwiperContainerImg'
                        onClick={() => navigate('/course-details', { state: { property_id: course.property_id } })}
                    >

                        {/* <Swiper
                            key={`${course.property_id}-${index}`}
                            modules={[Pagination, Autoplay]}
                            spaceBetween={10}
                            slidesPerView={1}
                            pagination={{ clickable: true }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false, // Keeps autoplay after user interaction
                            }}
                            className='swiperSearchResult'
                        // style={{ width: '100%', height: 150, borderRadius: 10 }}

                        >
                            {(course.photos ?? []).map((image: string, idx: number) => (
                                <SwiperSlide key={idx}>
                                    <img
                                        src={image}
                                        alt={`Preview ${idx + 1}`}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: 0,
                                        }}
                                    />
                                </SwiperSlide>
                            ))}

                        </Swiper> */}

                        <Swiper
                            key={`${course.property_id}-${index}`}
                            modules={[Pagination, Autoplay]}
                            spaceBetween={10}
                            slidesPerView={1}
                            pagination={{ clickable: true }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            className="swiperSearchResult"
                        >
                            {imagesToShow.map((image: string, idx: number) => (
                                <SwiperSlide key={idx}>
                                    <img
                                        src={image}
                                        alt={`Preview ${idx + 1}`}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: 0,
                                        }}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>


                    </div>

                    <div style={{ width: '100%', position: "relative", borderRadius: "10px" }}>
                        <div style={{ display: 'flex', marginLeft: 10, padding: "22px 10px" }}>
                            <div>
                                <p className='typeOfRoom' >Semi Furnished</p>
                                <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold }}>
                                    ₹{course.minimum_rent}/Month
                                    {/* ₹5000/Month */}
                                </text.T16>

                                <div style={{ paddingBottom: "8px" }}> {course.property_name}</div>
                                {/* <elements.CourseName
                                    course={course}
                                    numberOfLines={1}
                                    shortName={true}
                                /> */}
                                <p className='addressCard'>
                                    {`${course.address}, ${course.city_name}, ${course.pincode}`}
                                </p>
                                {/* <elements.areaDescription course={course} /> */}
                                <div className="pg-card-features">
                                    {(course.features ?? []).slice(0, 3).map((feature) => (
                                        <span key={feature.feature_id} className="feature-tag">
                                            {feature.feature_name}
                                        </span>
                                    ))}
                                    {course.features && course.features.length > 3 && (
                                        <span
                                            className="feature-tag more-tag"
                                            onClick={() => navigate("/course-details", { state: { course } })}
                                        >
                                            +{course.features.length - 3} more
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* <elements.CourseRating
                            course={course}
                            containerStyle={{
                                margin: 2,
                                position: 'absolute',
                                top: 30,
                                right: 7,
                            }}
                        /> */}


                        {/* <CourseInWishlist
                            course={course}
                            size={20}
                            style={{ position: 'absolute', right: 17, top: 8 }}
                        /> */}


                        {/* <div style={{ position: 'absolute', right: 17, top: 8 }}>
                            <BookingSvg
                                course={course}
                                size={20} />
                        </div> */}
                        <div style={{ display: 'flex', width: '100%', marginBottom: "15px", gap: 10, padding: "0 14px" }}>
                            <button
                                style={{
                                    flex: 1,
                                    padding: '12px 0',
                                    border: 'none',
                                    borderRadius: '8px',
                                    backgroundColor: '#ededed',
                                    color: '#7065f0',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 600,
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                    transition: 'background-color 0.3s ease',
                                    fontSize: "14px"

                                }}
                                onClick={() => window.open('tel:+911234567890')}
                            >
                                {/* Explore */}
                                Contact Owner

                            </button>
                            <button
                                style={{
                                    flex: 1,
                                    padding: '12px 0',
                                    border: 'none',
                                    borderRadius: '8px',
                                    backgroundColor: '#7065F0',
                                    color: 'white',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 600,
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                    transition: 'background-color 0.3s ease',
                                    fontSize: "14px"
                                }}
                                // onClick={() => navigate("/room-type")}
                                // onClick={() =>
                                //     navigate("/room-type", {
                                //         state: {
                                //             property_id: course?.property_id,
                                //             // property_name: propertiesDetailsData?.property_name,
                                //         },
                                //     })
                                // }
                                onClick={() => {
                                    const propertyId = course?.property_id;
                                    const propertyName = course?.property_name;

                                    // ✅ Only store if property_id exists
                                    if (propertyId) {
                                        sessionStorage.setItem("property_id", propertyId);
                                    }

                                    if (propertyName) {
                                        sessionStorage.setItem("property_name", propertyName);
                                    }

                                    navigate("/room-type", {
                                        state: {
                                            property_id: propertyId,
                                            property_name: propertyName,
                                        },
                                    });
                                }}
                            // onMouseOver={e => (e.currentTarget.style.backgroundColor = '#5e54e0')}
                            // onMouseOut={e => (e.currentTarget.style.backgroundColor = '#7065F0')}
                            >
                                Book Now
                            </button>
                        </div>



                    </div>
                </div>


            </div>
        </div >
    );
};



// 07-06-2025 code
// import React from 'react';
// import { CourseType } from '../types';
// import { text } from '../text';
// import { utils } from '../utils';
// import { hooks } from '../hooks';
// import { theme } from '../constants';
// import { course as elements } from '../course';
// import { CourseInWishlist } from './CourseInWishlist';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Autoplay } from 'swiper/modules'; // ✅ Swiper pagination module
// import 'swiper/css';
// import 'swiper/css/pagination'; // ✅ Swiper dots style



// type Props = {
//     isLast?: boolean;
//     course: CourseType;
//     section: 'top rated';
//     index: number;
// };

// export const SerachResultCard: React.FC<Props> = ({
//     course,
//     section,
//     isLast,
//     index
// }) => {
//     const navigate = hooks.useNavigate();

//     return (
//         <div className='container' >
//             <div
//                 className='sperate-card-container'
//                 onClick={() => navigate('/course-details', { state: { course } })}

//             >
//                 <div className='sperate-card-container_img' >
//                     <div className='SwiperContainerImg'>

//                         <Swiper
//                             key={`${course.id}-${index}`}
//                             modules={[Pagination, Autoplay]}
//                             spaceBetween={10}
//                             slidesPerView={1}
//                             pagination={{ clickable: true }}
//                             autoplay={{
//                                 delay: 3000,
//                                 disableOnInteraction: false, // Keeps autoplay after user interaction
//                             }}
//                             className='swiperSearchResult'
//                         // style={{ width: '100%', height: 150, borderRadius: 10 }}

//                         >
//                             {(course.previewImages || [course.preview_90x90]).map((image, idx) => (
//                                 <SwiperSlide key={idx}>
//                                     <img
//                                         src={image}
//                                         alt={`Preview ${idx + 1}`}
//                                         style={{
//                                             width: '100%',
//                                             height: '100%',
//                                             objectFit: 'cover',
//                                             borderRadius: 10,
//                                         }}
//                                     />
//                                 </SwiperSlide>
//                             ))}
//                         </Swiper>


//                     </div>

//                     <div style={{ width: '100%', position: "relative" }}>
//                         <div style={{ display: 'flex', marginLeft: 10, }}>
//                             <div>
//                                 <p className='typeOfRoom' >Semi Furnished</p>
//                                 <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold }}>
//                                     ₹{course.price}/Month
//                                     {/* ₹5000/Month */}
//                                 </text.T16>
//                                 <elements.CourseName
//                                     course={course}
//                                     numberOfLines={1}
//                                     shortName={true}
//                                 />
//                                 <p className='addressCard' >
//                                     Model Town, New Delhi
//                                 </p>
//                                 {/* <elements.areaDescription course={course} /> */}
//                             </div>
//                         </div>
//                         <elements.CourseRating
//                             course={course}
//                             containerStyle={{
//                                 margin: 2,
//                                 position: 'absolute',
//                                 top: 30,
//                                 right: 7,
//                             }}
//                         />
//                         <CourseInWishlist
//                             course={course}
//                             size={20}
//                             style={{ position: 'absolute', right: 17, top: 8 }}
//                         />
//                     </div>
//                 </div>

//                 <div className="info-row">
//                     <div className="info-item highlight">
//                         <p className="label">Security Deposit</p>
//                         <p className="value">₹ 5,000</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Agreement</p>
//                         <p className="value">3 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Locking Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Notice Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                 </div>

//             </div>
//         </div >
//     );
// };


























// Working Code

// import React from 'react';
// import { CourseType } from '../types';
// import { text } from '../text';
// import { utils } from '../utils';
// import { hooks } from '../hooks';
// import { theme } from '../constants';
// import { course as elements } from '../course';
// import { CourseInWishlist } from './CourseInWishlist';

// type Props = {
//     isLast?: boolean;
//     course: CourseType;
//     section: 'top rated';
// };

// export const SerachResultCard: React.FC<Props> = ({
//     course,
//     section,
//     isLast,
// }) => {
//     const navigate = hooks.useNavigate();

//     return (
//         <div className='container' >
//             <div
//                 className='sperate-card-container'
//                 onClick={() => navigate('/course-details', { state: { course } })}

//             >


//                 <div style={{ display: "flex" }}>
//                     <div
//                         style={{
//                             minWidth: 140,
//                             minHeight: 110,
//                             marginRight: 12,
//                             position: 'relative',
//                         }}
//                     >

//                         <img
//                             src={course.preview_90x90}
//                             style={{
//                                 width: '100%',
//                                 height: '100%',
//                                 borderRadius: 10,
//                                 position: 'absolute',
//                                 inset: 0,
//                             }}
//                         />
//                         <elements.CourseRating
//                             course={course}
//                             containerStyle={{
//                                 margin: 2,
//                                 position: 'absolute',
//                                 bottom: 0,
//                                 left: 0,
//                             }}
//                         />
//                     </div>
//                     <div style={{ width: '100%', position: 'relative' }}>
//                         <div style={{ display: 'flex', marginLeft: 10 }}>
//                             <div>
//                                 <p className='typeOfRoom' >Semi Furnished</p>
//                                 <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold }}>
//                                     ₹{course.price}/Month
//                                     {/* ₹5000/Month */}
//                                 </text.T16>
//                                 <elements.CourseName
//                                     course={course}
//                                     numberOfLines={1}
//                                     shortName={true}
//                                 />
//                                 <text.T16 style={{ color: "#000" }}>
//                                     Model Town, New Delhi
//                                 </text.T16>
//                                 {/* <elements.areaDescription course={course} /> */}
//                             </div>
//                         </div>
//                         <CourseInWishlist
//                             course={course}
//                             size={20}
//                             style={{ position: 'absolute', left: -39, top: 8 }}
//                         />
//                     </div>
//                 </div>

//                 <div className="info-row">
//                     <div className="info-item highlight">
//                         <p className="label">Security Deposit</p>
//                         <p className="value">₹ 5,000</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Agreement</p>
//                         <p className="value">3 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Locking Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Notice Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                 </div>

//             </div>
//         </div >
//     );
// };







// ****************OLD CODE **********************************

// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { utils } from '../utils';
// import { hooks } from '../hooks';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { CourseType } from '../types';
// import { course as elements } from '../course';

// type Props = {
//     isLast?: boolean;
//     course: CourseType;
//     status?: 'ongoing' | 'completed';
//     section: 'top rated' | 'category list' | 'my courses' | 'Recommanded For you';
// };

// export const SerachResultCard: React.FC<Props> = ({
//     course,
//     section,
//     isLast,
//     status,
// }) => {
//     const navigate = hooks.useNavigate();

//     if (section === 'top rated') {
//         return (
//             <div
//                 style={{
//                     width: '100%',
//                     padding: '0 20px',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                     ...utils.rowCenter(),
//                     marginBottom: isLast ? 0 : 10,
//                     paddingBottom: isLast ? 0 : 10,
//                     borderBottomWidth: isLast ? 0 : 1,
//                     borderBottomStyle: isLast ? 'none' : 'solid',
//                     borderBottomColor: `rgba(59, 89, 153, 0.1)`,
//                 }}
//                 onClick={() => navigate('/course-details', { state: { course } })}
//             >
//                 <div
//                     style={{
//                         minWidth: 140,
//                         minHeight: 110,
//                         marginRight: 12,
//                         position: 'relative',
//                     }}
//                 >
//                     <img
//                         src={course.preview_90x90}
//                         style={{
//                             width: '100%',
//                             height: '100%',
//                             borderRadius: 10,
//                             position: 'absolute',
//                             inset: 0,
//                         }}
//                     />
//                     <elements.CourseRating
//                         course={course}
//                         containerStyle={{
//                             margin: 2,
//                             position: 'absolute',
//                             bottom: 0,
//                             left: 0,
//                         }}
//                     />
//                 </div>
//                 <div style={{ width: '100%', position: 'relative' }}>
//                     <div style={{ display: 'flex', marginLeft: 10 }}>
//                         <div>
//                             {/* {course.oldPrice && (
//                 <span
//                   style={{
//                     marginRight: 6,
//                     color: theme.colors.secondaryTextColor,
//                     textDecorationLine: 'line-through',
//                     ...theme.fonts.Lato_700Bold,
//                     fontSize: 18,
//                     lineHeight: 1.5,
//                     marginTop: 3,
//                   }}
//                 >
//                   ${course.oldPrice.toFixed(2)}
//                 </span>
//               )} */}
//                             <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
//                                 ${course.price.toFixed(2)}/Month
//                             </text.T16>
//                             <elements.CourseName
//                                 course={course}
//                                 numberOfLines={1}
//                                 shortName={true}
//                             />
//                             <text.T16 style={{ color: "#000" }}>
//                                 London University
//                             </text.T16>
//                             <elements.areaDescription
//                                 course={course}
//                             // numberOfLines={1}
//                             // shortName={true}
//                             />

//                         </div>
//                     </div>
//                     {/* <div style={{width: 202, marginRight: 30}}>
//             <text.H6
//               numberOfLines={2}
//               style={{marginBottom: 10}}
//             >
//               {course.name}
//             </text.H6>
//           </div> */}
//                     {/* <div style={{...utils.rowCenter()}}>
//             <svg.ClockSvg color={theme.colors.secondaryTextColor} />
//             <text.T14
//               style={{
//                 marginLeft: 6,
//                 marginRight: 'auto',
//                 color: theme.colors.secondaryTextColor,
//               }}
//             >
//               {course.duration}
//             </text.T14>
//             <elements.CoursePrice course={course} />
//           </div> */}
//                     <elements.CourseInWishlist
//                         course={course}
//                         size={20}
//                         style={{ position: 'absolute', right: 0, top: 0 }}
//                     />
//                 </div>
//             </div>
//         );
//     }

//     if (section === 'category list') {
//         return (
//             <div
//                 style={{
//                     width: '100%',
//                     padding: '0 20px',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                     ...utils.rowCenter(),
//                     marginBottom: isLast ? 0 : 10,
//                     paddingBottom: isLast ? 0 : 10,
//                     borderBottomWidth: isLast ? 0 : 1,
//                     borderBottomStyle: isLast ? 'none' : 'solid',
//                     borderBottomColor: `rgba(59, 89, 153, 0.1)`,
//                 }}
//                 onClick={() => navigate('/course-details', { state: { course } })}
//             >
//                 <div
//                     style={{
//                         minWidth: 90,
//                         minHeight: 90,
//                         marginRight: 12,
//                         position: 'relative',
//                     }}
//                 >
//                     <img
//                         src={course.preview_90x90}
//                         style={{
//                             width: '100%',
//                             height: '100%',
//                             borderRadius: 10,
//                             position: 'absolute',
//                             inset: 0,
//                         }}
//                     />
//                     <elements.CourseRating
//                         course={course}
//                         containerStyle={{
//                             margin: 2,
//                             position: 'absolute',
//                             bottom: 0,
//                             left: 0,
//                         }}
//                     />
//                 </div>
//                 <div style={{ width: '100%', position: 'relative' }}>
//                     <div style={{ display: 'flex', marginLeft: 10 }}>
//                         <div>
//                             {/* {course.oldPrice && (
//                 <span
//                   style={{
//                     marginRight: 6,
//                     color: theme.colors.secondaryTextColor,
//                     textDecorationLine: 'line-through',
//                     ...theme.fonts.Lato_700Bold,
//                     fontSize: 18,
//                     lineHeight: 1.5,
//                     marginTop: 3,
//                   }}
//                 >
//                   ${course.oldPrice.toFixed(2)}
//                 </span>
//               )} */}
//                             <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
//                                 ${course.price.toFixed(2)}/Month
//                             </text.T16>
//                             <elements.CourseName
//                                 course={course}
//                                 numberOfLines={1}
//                                 shortName={true}
//                             />
//                             <text.T16 style={{ color: "#000" }}>
//                                 London University
//                             </text.T16>
//                             <elements.areaDescription
//                                 course={course}
//                             // numberOfLines={1}
//                             // shortName={true}
//                             />
//                             <elements.CourseInWishlist
//                                 course={course}
//                                 size={20}
//                                 style={{ position: 'absolute', right: 0, top: 0 }}
//                             />
//                         </div>
//                     </div>
//                     {/* <div style={{ width: 202, marginRight: 30 }}>
//             <text.H6
//               numberOfLines={2}
//               style={{ marginBottom: 10 }}
//             >
//               {course.name}
//             </text.H6>
//           </div>
//           <div style={{ ...utils.rowCenter() }}>
//             <svg.ClockSvg />
//             <text.T14 style={{ marginLeft: 6, marginRight: 'auto' }}>
//               {course.duration}
//             </text.T14>
//             <elements.CoursePrice course={course} />
//           </div>
//          */}
//                 </div>
//             </div>
//         );
//     }

//     if (section === 'my courses') {
//         return (
//             <button
//                 className='custom-block'
//                 style={{
//                     width: '48%',
//                     borderRadius: 10,
//                     marginBottom: 15,
//                 }}
//             >
//                 <div
//                     style={{ height: 96, position: 'relative' }}
//                     onClick={() => navigate('/course-details', { state: { course } })}
//                 >
//                     <img
//                         src={course.preview_90x90}
//                         alt='course'
//                         style={{
//                             height: '100%',
//                             borderTopLeftRadius: 10,
//                             borderTopRightRadius: 10,
//                             objectFit: 'cover',
//                         }}
//                     />
//                     <div
//                         style={{
//                             position: 'absolute',
//                             top: 0,
//                             right: 0,
//                             width: '100%',
//                             height: '100%',
//                             backgroundColor: 'rgba(0, 0, 0, 0.1)',
//                             borderTopRightRadius: 10,
//                             borderTopLeftRadius: 10,
//                         }}
//                     />
//                     <svg.PlayBtnSvg
//                         style={{
//                             position: 'absolute',
//                             top: '50%',
//                             left: '50%',
//                             transform: 'translate(-50%, -50%)',
//                         }}
//                     />
//                 </div>
//                 <div style={{ padding: '11px 14px 14px 14px' }}>
//                     <text.T14
//                         numberOfLines={2}
//                         style={{ color: theme.colors.mainColor }}
//                     >
//                         {course.name}
//                     </text.T14>
//                     {status === 'ongoing' && (
//                         <div>
//                             <div
//                                 style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     marginTop: 8,
//                                     justifyContent: 'space-between',
//                                 }}
//                             >
//                                 <text.T12
//                                     style={{
//                                         color: theme.colors.secondaryTextColor,
//                                         ...theme.fonts.Lato_400Regular,
//                                     }}
//                                 >
//                                     56%
//                                 </text.T12>
//                                 <div style={{ ...utils.rowCenter({ gap: 3 }) }}>
//                                     <svg.StarSvg />
//                                     <text.T10
//                                         style={{
//                                             ...theme.fonts.Lato_700Bold,
//                                             color: theme.colors.mainColor,
//                                         }}
//                                     >
//                                         {course.rating}
//                                     </text.T10>
//                                 </div>
//                             </div>
//                             <div
//                                 style={{
//                                     width: '100%',
//                                     height: 3,
//                                     backgroundColor: '#C3D9FD',
//                                     borderRadius: 3,
//                                 }}
//                             >
//                                 <div
//                                     style={{
//                                         width: '56%',
//                                         height: 3,
//                                         backgroundColor: '#55ACEE',
//                                         borderRadius: 3,
//                                     }}
//                                 />
//                             </div>
//                         </div>
//                     )}
//                     {status === 'completed' && (
//                         <button
//                             style={{
//                                 width: '100%',
//                                 border: `1px solid ${theme.colors.secondaryTextColor}`,
//                                 borderRadius: 5,
//                                 marginTop: 6,
//                                 padding: '4px 0px',
//                                 ...utils.flexCenter(),
//                             }}
//                             onClick={() => navigate('/course-completed')}
//                         // onClick={() => navigate('/course-completed-certificate')}
//                         >
//                             <text.T10 style={{ color: theme.colors.mainColor }}>
//                                 View certificate
//                             </text.T10>
//                         </button>
//                     )}
//                 </div>
//             </button>
//         );
//     }

//     return null;
// };



